import axios from "axios";
import store from "@/vuex";

/**
 * 上传 excel 文件
 */
//1.上传文件校验
// const uploadCheck = async () => {
//     try {
//         const file = new FormData()
//         file.append('file', importFile.value)
//         // 调用后端对应的接口
//         const res = await postFile(file)
//     } catch (error) {
//         console.log('error', error)
//     }
// }

// //2.导入（校验数据）
// export const postFile = (data) => {
//     return axios.post({
//         url: `上传地址`,
//         data,
//         headers: {
//             'Content-Type': 'multipart/form-data'
//         }
//     })
// }


/**
 * 下载 excel 文件
 */

// 1.导入模板下载
export const downloadFile = (url, params = {}) => {
    // const formParams = new FormData();
    // Object.keys(params).forEach(key => {
    //     formParams.append(key, params[key])
    // })
    // 又改成JSON
    const formParams = params;
    // return axios.post({
    //     url: url,
    //     data: formParams,
    //     responseType: 'blob', // 指定响应类型为 blob
    //     headers: {
    //         "Authorization": store.getters.token,
    //         'Content-type': 'multipart/form-data'
    //     }
    // })
    return axios.post(url, formParams,
        {
            responseType: 'blob', // 指定响应类型为 blob
            headers: {
                "Authorization": store.getters.token,
                // 'Content-type': 'multipart/form-data'
            }
        })
}

/**
 * 二进制流转excel下载
 * @param tSource
 * @returns
 */
export const exportExcel = function (blob, name) {
    // application/octet-stream;charset=UTF-8
    // application/vnd.ms-excel
    let url = window.URL.createObjectURL(new Blob([blob], { type: "application/octet-stream;charset=UTF-8" }))
    // url = url.replace(location.origin + '/', process.env.VUE_APP_BASE_URL)
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name + '.xls'); // 设置文件名
    document.body.appendChild(link);
    link.click(); // 模拟点击下载文件
    document.body.removeChild(link); // 下载完成后移除元素
    window.URL.revokeObjectURL(url); // 释放URL对象
}


export const downLoadFileExcelHandle = async (url, params = {}, templateName = 'excel模板') => {
    console.log(url, params, templateName)
    try {
        const res = await downloadFile(url, params)
        if (res) {
            // const newRes = res
            exportExcel(res.data, templateName)
        }
    } catch (error) {
        console.log(error)
    }
}